import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

/**
 * Email / universal-link landing: /plaid-link?plaidItemId=...
 * Forwards to Money with openPlaidUpdate when an item id is present.
 */
export default function PlaidLinkRedirect() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const next = new URLSearchParams();
    const itemId = searchParams.get('plaidItemId') || searchParams.get('itemId');
    if (itemId) {
      next.set('plaidItemId', itemId);
      next.set('openPlaidUpdate', 'true');
    }
    const accountId = searchParams.get('accountId');
    if (accountId) {
      next.set('accountId', accountId);
    }
    if (searchParams.get('accountSelectionEnabled') === 'true') {
      next.set('accountSelectionEnabled', 'true');
    }
    const query = next.toString();
    navigate(query ? `/money?${query}` : '/money', { replace: true });
  }, [navigate, searchParams]);

  return null;
}
